<template functional>
  <text-field
    mask="### ### #####"
    :v-rules="[parent.$utils.rules.telephone]"
    :value="props.value"
    v-bind="data.attrs"
    v-on="listeners"/>
</template>
<script>
export default {
    name: 'MobilePhoneField',
    props: {
        value: String
    }
}
</script>
